// App Initializer
export const APP_INITIALIZER_FAILURE = 'APP_INITIALIZER_FAILURE';
export const REQUEST_APP_INITIALIZER = 'REQUEST_APP_INITIALIZER';

// Current User
export const RECEIVE_CURRENT_USER_DETAILS = 'RECEIVE_CURRENT_USER_DETAILS';
export const REQUEST_CURRENT_USER_DETAILS = 'REQUEST_CURRENT_USER_DETAILS';

// Proxy User
export const RECEIVE_USER_DETAILS = 'RECEIVE_USER_DETAILS';
export const REQUEST_USER_DETAILS = 'REQUEST_USER_DETAILS';

// Feature
export const RECEIVE_FEATURES = 'RECEIVE_FEATURES';
export const REQUEST_FEATURES = 'REQUEST_FEATURES';

// Season
export const FIELD_NOT_FOUND_FAILURE = 'FIELD_NOT_FOUND_FAILURE';
export const RECEIVE_SELECTOR_VALS = 'RECEIVE_SELECTOR_VALS';
export const SET_ACTIVE_SELECTOR_VALS = 'SET_ACTIVE_SELECTOR_VALS';
export const SET_ACTIVE_SUB_LAYER = 'SET_ACTIVE_SUB_LAYER';
export const SET_FHA_TIMELAPSE_PLAYING = 'SET_FHA_TIMELAPSE_PLAYING';

// Planting
export const REQUEST_PLANTING_METADATA = 'REQUEST_PLANTING_METADATA';
export const RECEIVE_PLANTING_METADATA = 'RECEIVE_PLANTING_METADATA';
export const FAILURE_PLANTING_METADATA = 'FAILURE_PLANTING_METADATA';
export const REQUEST_PLANTING_ANALYTICS = 'REQUEST_PLANTING_ANALYTICS';
export const RECEIVE_PLANTING_ANALYTICS = 'RECEIVE_PLANTING_ANALYTICS';
export const FAILURE_PLANTING_ANALYTICS = 'FAILURE_PLANTING_ANALYTICS';

// Farm
export const REQUEST_FARM_DETAILS = 'REQUEST_FARM_DETAILS';
export const RECEIVE_FARM_DETAILS = 'RECEIVE_FARM_DETAILS';
export const FAILURE_FARM_DETAILS = 'FAILURE_FARM_DETAILS';

// Field
export const RECEIVE_FIELD = 'RECEIVE_FIELD';

// Product Assets
export const RECEIVE_PRODUCT_ASSETS = 'RECEIVE_PRODUCT_ASSETS';

// Map
export const ACTIVATE_MAP = 'ACTIVATE_MAP';
export const RECENTER = 'RECENTER';
export const UPDATE_VIEWPORT = 'UPDATE_VIEWPORT';
export const TOGGLE_PIN = 'TOGGLE_PIN';
export const SET_PLACING_PIN = 'SET_PLACING_PIN';

// Sharing
export const RECEIVE_FIELD_PERMISSION = 'RECEIVE_FIELD_PERMISSION';

// Soil SSURGO
export const REQUEST_SOIL_SSURGO_ZONES = 'REQUEST_SOIL_SSURGO_ZONES';
export const RECEIVE_SOIL_SSURGO_ZONES = 'RECEIVE_SOIL_SSURGO_ZONES';
export const SOIL_SSURGO_ZONES_FAILURE = 'SOIL_SSURGO_ZONES_FAILURE';

// Weather
export const REQUEST_WEATHER_DATA = 'REQUEST_WEATHER_DATA';
export const RECEIVE_WEATHER_DATA = 'RECEIVE_WEATHER_DATA';
export const FAILURE_WEATHER_DATA = 'FAILURE_WEATHER_DATA';
export const REQUEST_WEATHER_OBSERVATIONS = 'REQUEST_WEATHER_OBSERVATIONS';
export const RECEIVE_WEATHER_OBSERVATIONS = 'RECEIVE_WEATHER_OBSERVATIONS';
export const FAILURE_WEATHER_OBSERVATIONS = 'FAILURE_WEATHER_OBSERVATIONS';

// operations
export const RECEIVE_OPERATIONS = 'RECEIVE_OPERATIONS';
export const RECEIVE_OPERATIONS_AND_FIELDS = 'RECEIVE_OPERATIONS_AND_FIELDS';
export const RECEIVE_MULTIPLE_OPERATIONS = 'RECEIVE_MULTIPLE_OPERATIONS';
export const RECEIVE_MULTIPLE_OPERATIONS_AND_FIELDS = 'RECEIVE_MULTIPLE_OPERATIONS_AND_FIELDS';

// Fields
export const RECEIVE_FIELDS = 'RECEIVE_FIELDS';
export const RECEIVE_FIELDS_FAILURE = 'RECEIVE_FIELDS_FAILURE';
export const RECEIVE_FIELDS_MULTI_OPERATIONS = 'RECEIVE_FIELDS_MULTI_OPERATIONS'
export const RECEIVE_FIELDS_FAILURE_MULTI_OPERATIONS = 'RECEIVE_FIELDS_FAILURE_MULTI_OPERATIONS';
export const REQUEST_FIELD_SEARCH_INDEX = 'REQUEST_FIELD_SEARCH_INDEX';
export const RECEIVE_FIELD_SEARCH_INDEX = 'RECEIVE_FIELD_SEARCH_INDEX';
export const FIELD_SEARCH_INDEX_FAILURE = 'FIELD_SEARCH_INDEX_FAILURE';
export const SEARCH_FIELDS_BY_NAME = 'SEARCH_FIELDS_BY_NAME';
export const RECEIVE_FIELD_NAME_SEARCH_RESULTS = 'RECEIVE_FIELD_NAME_SEARCH_RESULTS';
export const CLEAR_FIELD_NAME_SEARCH = 'CLEAR_FIELD_NAME_SEARCH';

// Imported Shapefiles
export const REQUEST_IMPORTED_SHAPEFILE_DATA =
  'REQUEST_IMPORTED_SHAPEFILE_DATA';
export const RECEIVE_IMPORTED_SHAPEFILE_DATA =
  'RECEIVE_IMPORTED_SHAPEFILE_DATA';
export const IMPORTED_SHAPEFILE_DATA_FAILURE =
  'IMPORTED_SHAPEFILE_DATA_FAILURE';

// Scouting
export const REQUEST_NEW_ACTIVITY = 'REQUEST_NEW_ACTIVITY';
export const RECEIVE_NEW_ACTIVITY = 'RECEIVE_NEW_ACTIVITY';
export const FAILURE_NEW_ACTIVITY = 'FAILURE_NEW_ACTIVITY';

export const REQUEST_DELETE_ACTIVITY = 'REQUEST_DELETE_ACTIVITY';
export const RECEIVE_DELETE_ACTIVITY = 'RECEIVE_DELETE_ACTIVITY';
export const FAILURE_DELETE_ACTIVITY = 'FAILURE_DELETE_ACTIVITY';

export const REQUEST_UPDATE_ACTIVITY = 'REQUEST_UPDATE_ACTIVITY';
export const RECEIVE_UPDATE_ACTIVITY = 'RECEIVE_UPDATE_ACTIVITY';
export const FAILURE_UPDATE_ACTIVITY = 'FAILURE_UPDATE_ACTIVITY';

export const REQUEST_UPDATE_ENHANCED_ACTIVITY = 'REQUEST_UPDATE_ENHANCED_ACTIVITY'
export const FAILURE_UPDATE_ENHANCED_ACTIVITY = 'FAILURE_UPDATE_ENHANCED_ACTIVITY'

export const REQUEST_ACTIVITIES = 'REQUEST_ACTIVITIES';
export const RECEIVE_ACTIVITIES = 'RECEIVE_ACTIVITIES';
export const FAILURE_ACTIVITIES = 'FAILURE_ACTIVITIES';
export const SET_SELECTED_ACTIVITY = 'SET_SELECTED_ACTIVITY';

export const REQUEST_TAGS = 'REQUEST_TAGS';
export const RECEIVE_TAGS = 'RECEIVE_TAGS';
export const FAILURE_TAGS = 'FAILURE_TAGS';

export const REQUEST_OBSERVATIONS = 'REQUEST_OBSERVATIONS';
export const RECEIVE_OBSERVATIONS = 'RECEIVE_OBSERVATIONS';
export const FAILURE_OBSERVATIONS = 'FAILURE_OBSERVATIONS';

export const REQUEST_CATEGORY = 'REQUEST_CATEGORY';
export const RECEIVE_CATEGORY = 'RECEIVE_CATEGORY';
export const FAILURE_CATEGORY = 'FAILURE_CATEGORY';

export const REQUEST_OBSERVATIONS_ATTRIBUTES = 'REQUEST_OBSERVATIONS_ATTRIBUTES';
export const RECEIVE_OBSERVATIONS_ATTRIBUTES = 'RECEIVE_OBSERVATIONS_ATTRIBUTES';
export const FAILURE_OBSERVATIONS_ATTRIBUTES = 'FAILURE_OBSERVATIONS_ATTRIBUTES';

export const REQUEST_DELETE_ASSET = 'REQUEST_DELETE_ASSET';
export const RECEIVE_DELETE_ASSET = 'RECEIVE_DELETE_ASSET';
export const FAILURE_DELETE_ASSET = 'FAILURE_DELETE_ASSET';

export const START_DELETE_COMMENTS = 'START_DELETE_COMMENTS';
export const REQUEST_DELETE_COMMENTS = 'REQUEST_DELETE_COMMENTS';
export const RECEIVE_DELETE_COMMENTS = 'RECEIVE_DELETE_COMMENTS';

export const REQUEST_ACTIVITY = 'REQUEST_ACTIVITY';
export const EDIT_ACTIVITY = 'EDIT_ACTIVITY';
export const FAILURE_ACTIVITY = 'FAILURE_ACTIVITY';

// Scripts
export const RECEIVE_SCRIPTS = 'RECEIVE_SCRIPTS';
export const FAILURE_SCRIPTS = 'FAILURE_SCRIPTS';

// Analytics
export const TRACK_EVENT = 'TRACK_EVENT';
export const TRACK_HEAP_EVENT = 'TRACK_HEAP_EVENT';

// Layers
export const GET_MOSAIC_LAYERS_FAILURE = 'GET_MOSAIC_LAYERS_FAILURE';